/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React__default from 'react';
import cx from 'classnames';
import { usePrefix } from '../../internal/usePrefix.js';

var _span, _Tab, _Tab2, _Tab3, _Tab4, _Tab5;
function Tab() {
  const prefix = usePrefix();
  return /*#__PURE__*/React__default.createElement("li", {
    className: `${prefix}--tabs__nav-item`
  }, /*#__PURE__*/React__default.createElement("div", {
    className: `${prefix}--tabs__nav-link`
  }, _span || (_span = /*#__PURE__*/React__default.createElement("span", null))));
}
function TabsSkeleton(_ref) {
  let {
    className,
    contained,
    ...rest
  } = _ref;
  const prefix = usePrefix();
  const tabClasses = cx(className, `${prefix}--tabs`, `${prefix}--skeleton`, {
    [`${prefix}--tabs--contained`]: contained
  });
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: tabClasses
  }, rest), /*#__PURE__*/React__default.createElement("ul", {
    className: `${prefix}--tabs__nav`
  }, _Tab || (_Tab = /*#__PURE__*/React__default.createElement(Tab, null)), _Tab2 || (_Tab2 = /*#__PURE__*/React__default.createElement(Tab, null)), _Tab3 || (_Tab3 = /*#__PURE__*/React__default.createElement(Tab, null)), _Tab4 || (_Tab4 = /*#__PURE__*/React__default.createElement(Tab, null)), _Tab5 || (_Tab5 = /*#__PURE__*/React__default.createElement(Tab, null))));
}
TabsSkeleton.propTypes = {
  /**
   * Specify an optional className to add.
   */
  className: PropTypes.string,
  /**
   * Provide the type of Tab
   */
  contained: PropTypes.bool
};

export { TabsSkeleton, TabsSkeleton as default };
